module.exports = __webpack_public_path__ + "static/media/b.78157938.jpg";